import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {number} channelId
 * @return {Promise<Object>}
 */
export async function createEnableVoice(channelId) {
  const url = `/channels/channel-customer/${channelId}/enable-voice/`;
  const response = await httpManager.post(url);
  return response?.data;
}